// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ViewComfyIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 18 14">
    <path
      fill="currentColor"
      d="M0 3.79h3.79V0H0zm0 4.74h3.79v-3.8H0zm4.74 0h3.79v-3.8h-3.8zm4.73 0h3.8v-3.8h-3.8zM4.74 3.79h3.79V0h-3.8zM9.47 0v3.79h3.8V0zm4.74 8.53H18v-3.8h-3.79zM0 13.26h3.79V9.47H0zm4.74 0h3.79V9.47h-3.8zm4.73 0h3.8V9.47h-3.8zm4.74 0H18V9.47h-3.79zm0-13.26v3.79H18V0z"
    />
  </svg>,
  "ViewComfy",
);
export default ViewComfyIcon;
